import {
  NOTIFICATION_EVENT_TYPE,
  NotificationItem as NotificationItemType,
} from "api/interfaces/notificationInterface.interface";
import { ReactComponent as IconRead } from "assets/icons/notification/icon_read.svg";
import { WithTooltip } from "components/blocks/WithTooltip";
import * as s from "./NotificationStyle";
import { useNotification } from "./NotificationContainer";
import { useEffect, useState } from "react";
import {
  convertKindToIcon,
  convertKindToText,
  convertMsg,
  convertTime,
} from "utils/NotificationUtil";
import { useAppSelector } from "redux/hooks";
import { COLORS } from "styles/colors";
import { StompMessageKind } from "redux/stomp/interface";

//알림 리스트 아이템 컴포넌트
const NotificationItem = ({ item }: { item: NotificationItemType }) => {
  const { notiTime, notiId, eventType, kind, isRead } = item;
  const [isReadStatus, setIsReadStatus] = useState(isRead);
  const theme = useAppSelector((state) => state.theme.theme);
  const selectAccount = useAppSelector((state) => state.accountSettings);
  const { navigateToNotification, onChangeReadStatus } = useNotification();
  useEffect(() => {
    setIsReadStatus(isRead);
  }, [isRead]);
  return (
    <s.NotificationItem
      isRead={isReadStatus}
      noLink={
        item.kind === StompMessageKind.ORGANIZATION &&
        item.eventType === NOTIFICATION_EVENT_TYPE.DELETE
      }
    >
      <span>{convertKindToIcon(item)}</span>
      <div
        onClick={(e) => {
          e.stopPropagation();
          navigateToNotification(item);
        }}
        data-testid="blocks-headernav-notification-navigate"
      >
        <h3>
          <b>{convertKindToText(item)}</b>
          <small>{convertTime(notiTime, selectAccount)}</small>
        </h3>
        <p>{convertMsg(item)}</p>
      </div>
      {!isReadStatus && (
        <s.NotificationReadButton
          onClick={async (e) => {
            e.stopPropagation();
            const response = await onChangeReadStatus(item);
            if (response?.notiId === notiId) {
              setIsReadStatus(true);
            }
          }}
          data-testid="blocks-headernav-notification-read-button"
        >
          <WithTooltip
            tooltip="Mark as read"
            style={
              theme === "light"
                ? {}
                : { backgroundColor: COLORS.WHITE, color: COLORS.BLACK }
            }
          >
            <IconRead />
          </WithTooltip>
        </s.NotificationReadButton>
      )}
    </s.NotificationItem>
  );
};
export default NotificationItem;
